export enum RegisteredByEnum {
    Store = 0,
    DSHS = 1,
    Self =2
}